import { ENV_PREPROD, ENV_PROD } from 'constants/environment';

/**
 * Base publique d'Odoo vue du navigateur. L'API ne sert `odooSupplierUrl` & co. que si
 * `ODOO_PUBLIC_URL` est configuré (prod, preprod) : en local elle renvoie `null`, alors que le
 * back-office sait très bien construire le lien seul.
 */
export const getOdooBaseUrl = (): string => {
    switch (window.__TOTENV__.ENV) {
        case ENV_PROD:
            return 'https://odoo.neocorner.fr';
        case ENV_PREPROD:
            return 'https://odoo-preprod.totem.co';
        default:
            return 'https://odoo-inte.totem.co';
    }
};

/** Fiche `res.partner` (client ou fournisseur) dans Odoo. */
export const getOdooPartnerUrl = (odooPartnerId: number): string =>
    `${getOdooBaseUrl()}/web#id=${odooPartnerId}&model=res.partner&view_type=form`;
